import { ICardDescriptionData } from './types';
import { CARD_DESCRIPTION_DATA_SESSIONSTORAGE } from './constants';

export const setCardDescriptionData = (data: ICardDescriptionData) => {
    sessionStorage.setItem(CARD_DESCRIPTION_DATA_SESSIONSTORAGE, JSON.stringify(data));
}
